export const SuccessMessagesConfiguration = {
    AdditionalFormFields: {
        RegistrationSuccessful: {
            Title: process.env.REACT_APP_REGISTRATION_SUCCESSFUL_TITLE?.toString() ?? "Registration was successful",
            Content: process.env.REACT_APP_REGISTRATION_SUCCESSFUL_CONTENT?.toString() ?? ""
        }
    }
}